import React from 'react';

export default function SocialProof() {
  return (
    <section className="py-14 bg-white border-t border-slate-100">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center gap-6">
          <div className="flex-shrink-0">
            <p className="text-5xl font-black text-slate-900 leading-none tracking-tight">1 500+</p>
            <p className="text-lg text-slate-500 mt-1">pedagogů z MŠ, ZŠ a SŠ po celé ČR</p>
          </div>
          <div className="w-px h-14 bg-slate-200 flex-shrink-0" />
          <p className="text-slate-600 leading-relaxed max-w-sm">
            Tolik pedagogů už prošlo naším školením.<br />
            <strong className="text-slate-900">A v pondělí šli do školy jinak.</strong>
          </p>
        </div>
      </div>
    </section>
  );
}
